import { useState } from 'react';
import { FaRegFileAlt } from 'react-icons/fa';
import { MdOutlineFileDownload } from 'react-icons/md';
import { TrainingTypeEnum } from '@/constants/trainingTypeOptions';
import { useRegulatoryTrainingMatrix } from '@/hooks/useNewRegulatoryTrainingMatrix';
import { cn } from '@/utils/cn';
import { MesAno } from '@/utils/MesAno';
import { Button } from '../atoms/Button';
import LightTooltip from '../atoms/LightTooltip';
import { MatrixUpdatingCard } from '../atoms/MatrixUpdatingCard';
import TrainingModal from '../organisms/TrainingModal';
import NewRegulatoryTrainingMatrixAuditModal from './NewRegulatoryTrainingMatrixAuditModal';

export const NewRegulatoryTrainingMatrixPageHeader = () => {
	const {
		matrix: { refetch: refetchMatrix },
		downloadMatrix: { isDownloading, handleDownloadMatrix },
		downloadModifications: {
			isDownloadingModifications,
			handleDownloadModifications,
		},
		editions: {
			isOnEditionMode,
			setIsOnEditionMode,
			handleSaveEdition,
			isEditingMatrix,
		},
		permissions: {
			userIsAllowedToCheck,
			userIsAllowedToBlock,
			userIsAllowedToCreateTraining,
		},
	} = useRegulatoryTrainingMatrix();

	const [isNewTraininigModalOpen, setIsNewTraininigModalOpen] = useState(false);
	const [
		isModificationsDownloadModalOpen,
		setIsModificationsDownloadModalOpen,
	] = useState(false);
	const handleAllowEdition = () => {
		setIsOnEditionMode(true);
	};

	const onConfirmModificationsDownload = (
		monthAndYear: MesAno,
		allSinceMayOf26: boolean,
		allBeforeMayOf26: boolean,
	) => {
		handleDownloadModifications({
			startDate: allSinceMayOf26 ? undefined : monthAndYear.start,
			endDate: allSinceMayOf26 ? undefined : monthAndYear.end,
			allBeforeMayOf26: allBeforeMayOf26,
		});
	};

	return (
		<>
			{isEditingMatrix && <MatrixUpdatingCard />}
			{isNewTraininigModalOpen && (
				<TrainingModal
					isOpen={isNewTraininigModalOpen}
					onClose={() => setIsNewTraininigModalOpen(false)}
					matrixRefetch={refetchMatrix}
					trainingType={TrainingTypeEnum.REGULATORY}
				/>
			)}
			<div className="relative">
				<div className="flex gap-4 justify-end absolute -top-9 right-16 items-center">
					<Button
						className="h-7 rounded-[1rem] text-xs font-medium text-white"
						onClick={() => setIsNewTraininigModalOpen(true)}
						disabled={!userIsAllowedToCreateTraining}
					>
						Cadastrar Treinamento
					</Button>
					{isOnEditionMode ? (
						<Button
							className="h-7 rounded-[1rem] text-xs font-medium text-white"
							onClick={handleSaveEdition}
							disabled={!userIsAllowedToBlock && !userIsAllowedToCheck}
						>
							Salvar Matriz
						</Button>
					) : (
						<Button
							className="h-7 rounded-[1rem] text-xs font-medium text-white"
							onClick={handleAllowEdition}
							disabled={!userIsAllowedToBlock && !userIsAllowedToCheck}
						>
							Editar Matriz
						</Button>
					)}
					<LightTooltip title="Extrair matriz de treinamentos">
						<Button
							className={cn(
								'flex h-9 w-9 items-center justify-center rounded-full bg-transparent p-2 hover:bg-gray-200/70',
								isDownloading && 'cursor-not-allowed ',
							)}
							variant={'secondary'}
							onClick={handleDownloadMatrix}
							isLoading={isDownloading}
						>
							<MdOutlineFileDownload className="fill-gray-500" size={20} />
						</Button>
					</LightTooltip>
					<LightTooltip title="Extrair Relatório de Alterações da Matriz">
						<Button
							className={cn(
								'flex h-9 w-9 items-center justify-center rounded-full bg-transparent p-2 hover:bg-gray-200/70',
								isDownloadingModifications && 'cursor-not-allowed ',
							)}
							variant={'secondary'}
							onClick={() => setIsModificationsDownloadModalOpen(true)}
							isLoading={isDownloadingModifications}
						>
							<FaRegFileAlt className="fill-gray-500" size={20} />
						</Button>
					</LightTooltip>
				</div>
			</div>
			<NewRegulatoryTrainingMatrixAuditModal
				isOpen={isModificationsDownloadModalOpen}
				setIsOpen={setIsModificationsDownloadModalOpen}
				onConfirmation={onConfirmModificationsDownload}
				isLoading={isDownloadingModifications}
			/>
		</>
	);
};
